// Solicitor Contact List — ICT's shared lookup of solicitor email addresses.
// The daily Follow Up Report carries a ContactEmailAddresses column, but when
// the report isn't available ICT cross-references this list instead (ICT-7),
// and ICT-3's contest fallback solicitors come from it too. Ace resolves every
// outbound address here, so drafting never depends on a report being run.
export const SOLICITOR_CONTACT_LIST: Record<string, string> = {
  'Georgeson': 'proxy@georgeson.com',
  'Morrow Sodali': 'info@investor.morrowsodali.com',
  'D.F. King': 'proxy@dfking.com',
  'Alliance Advisors': 'contact@allianceadvisors.com',
  'Broadridge Financial Solutions': 'proxy.ops@broadridge.com',
  'Broadridge ICS - Proxy Desk': 'proxy.ops@broadridge.com',
  'Kingsdale Advisors': 'contact@kingsdaleadvisors.com',
  'Laurel Hill': 'assistance@laurelhill.com',
  'Mediant Communications': 'proxy@mediantonline.com',
  'Saratoga Proxy Consulting': 'intake@saratogaproxy.com',
  'Okapi Partners': 'contests@okapipartners.com',
  'Innisfree M&A Incorporated': 'contests@innisfreema.com',
  'Investorcom': 'contests@investorcom.com',
  'Campaign Management': 'contests@campaignmgmt.com',
};
